import TemplateActions from './TemplateActions';

export default TemplateActions;
